import ArticuloGeneralInfoFormFields from "./_shared/articulo-general-info-form-fields";
import { z } from "zod/v4";
import { Grid2 as Grid, Stack } from "@mui/material";
import ArticuloPrecioFormFields from "./_shared/articulo-precio-form-fields";
import ArticuloImageFormFields from "./_shared/articulo-image-form-fields";
import { useModalContext } from "@/components/modal";
import { Form, FormProps } from "@/components/form";

export const articuloFormSchema = z.object({
    codigo: z.string().nonempty("Este campo es requerido"),
    numeroItem: z.string().default(""),
    rubroId: z.string().nonempty("Este campo es requerido"),
    nombre: z.string().nonempty("Este campo es requerido"),
    costo: z.number({ message: "Este campo es requerido" }),
    iva: z.number({ message: "Este campo es requerido" }).default(10),
    descripcion: z.string().default(""),

    cantidadMinima: z.number().or(z.literal("")).default(""),
    cantidadPorCaja: z.number().or(z.literal("")).default(""),
    precios: z.array(z.number()).min(1, "Debe haber por lo menos 1 precio").max(3, "Solo puede haber un máximo 3 precios"),
    imagen: z.instanceof(File).nullable().default(null)
})

export default function ArticuloForm({
    form,
    ...props
}: FormProps<z.input<typeof articuloFormSchema>>) {
    const { code, handleClose } = useModalContext();

    return <Form form={form} gap={3} {...props}>
        <Grid container columns={{ xs: 1, sm: 3 }} spacing={3}>
            <Grid size={2}>
                <Stack gap={3}>
                    <ArticuloGeneralInfoFormFields />
                    <ArticuloPrecioFormFields />
                </Stack>
            </Grid>
            <Grid size={1}>
                <ArticuloImageFormFields />
            </Grid>
        </Grid>
        <Stack flexDirection={"row"} justifyContent={"end"} gap={3} position={{ md: "sticky" }} bottom={"24px"}>
            {code && <Form.Button onClick={handleClose}>Cancelar</Form.Button>}
            <Form.SubmitButton>Guardar</Form.SubmitButton>
        </Stack>
    </Form>
}